<template>
  <div class="rule-base-answer-log-wrapper">
    <div v-for="(msg, index) in data.answers" :key="`${uid}-rb-${index}`">
      <text-message
        v-if="msg.data_type && msg.data_type === 'text_message'"
        :data="msg"
        :direction="'outgoing'"
        :time="time"
        :channel="channel"
      ></text-message>
      <send-image
        v-else-if="msg.data_type && msg.data_type === 'image'"
        :data="msg"
        :direction="'outgoing'"
        :imgUrlField="'imageUrl'"
        :time="time"
        :channel="channel"
      ></send-image>
      <send-video
        v-else-if="msg.data_type && msg.data_type === 'video'"
        :data="msg"
        :direction="'outgoing'"
        :videoUrlField="'videoUrl'"
        :time="time"
        :channel="channel"
      ></send-video>
      <send-audio
        v-else-if="msg.data_type && msg.data_type === 'audio'"
        :data="msg"
        :direction="'outgoing'"
        :audioUrlField="'audioUrl'"
        :time="time"
        :channel="channel"
      ></send-audio>
      <button-template
        v-else-if="msg.data_type && msg.data_type === 'button_template'"
        :direction="'outgoing'"
        :data="msg"
        :time="time"
        :channel="channel"
      />
      <send-quickreply-template
        v-else-if="msg.data_type && msg.data_type === 'quick_reply'"
        :direction="'outgoing'"
        :data="msg"
        :time="time"
        :channel="channel"
      />
      <div v-else>Unknown rulebase type {{msg.data_type}}</div>
    </div>
  </div>
</template>
<script>
import textMessage from './TextMessage.vue';
import sendImage from './SendImage.vue';
import sendVideo from './SendVideo.vue';
import sendAudio from './SendAudio.vue';
import buttonTemplate from './ButtonTemplate.vue';
import sendQuickReplyTemplate from './SendQuickReplyTemplate.vue';

export default {
  name: 'sendRulebaseAnswer',
  components: {
    'text-message': textMessage,
    'send-image': sendImage,
    'send-video': sendVideo,
    'send-audio': sendAudio,
    'button-template': buttonTemplate,
    'send-quickreply-template': sendQuickReplyTemplate,
  },
  props: {
    data: {
      type: Object,
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
.rule-base-answer-log-wrapper {
  width: 100%;
}
</style>>
